import { useReducer, useEffect, useState } from 'react';

import ChartBarLine from '../../components/charts/chartBarLine/ChartBarLine';
import Relatorio from '../../components/results/relatorio/Relatorio';
import ChartEmissoes from '../../components/charts/chartEmissoes/ChartEmissoes';
import ChartRSU from '../../components/charts/chartRSU/ChartRSU';

import { calcularProjecao } from '../../utils/calculations';

const initialState = {
    redraw: false,
    showrsu: true,
    porTipo: false,
    biogas: false,
    recomendado: false,
    metaData: null,
    grapData: null,
    grapTitle: 'Resíduos Solidos Urbanos',
    nameA: 'Conservador',
    nameB: 'Recomendado',
    yName: 'Quantidade (t)',
    stepSize: 5000,
    maxAnos: 2030,
    minAnos: 2001
};

const actionTypes = {
    SET_RELOAD: 'SET_RELOAD',
    SET_SHOW_RSU: 'SET_SHOW_RSU',
    SET_POR_TIPO: 'SET_POR_TIPO',
    SET_BIOGAS: 'SET_BIOGAS',
    SET_RECOMENDADO: 'SET_RECOMENDADO',
    SET_META_DATA: 'SET_META_DATA',
    SET_GRAP_DATA: 'SET_GRAP_DATA',
    SET_GRAP_TITLE: 'SET_GRAP_TITLE',
    SET_NAME_A: 'SET_NAME_A',
    SET_NAME_B: 'SET_NAME_B',
    SET_Y_NAME: 'SET_Y_NAME',
    SET_STEP_SIZE: 'SET_STEP_SIZE',
    SET_MAX_ANOS: 'SET_MAX_ANOS',
    SET_MIN_ANOS: 'SET_MIN_ANOS'
};

function reducer(state, action) {
    switch (action.type) {
        case actionTypes.SET_RELOAD:
            return { ...state, redraw: action.payload };
        case actionTypes.SET_SHOW_RSU:
            return { ...state, showrsu: action.payload };
        case actionTypes.SET_POR_TIPO:
            return { ...state, porTipo: action.payload };
        case actionTypes.SET_BIOGAS:
            return { ...state, biogas: action.payload };
        case actionTypes.SET_RECOMENDADO:
            return { ...state, recomendado: action.payload };
        case actionTypes.SET_META_DATA:
            return { ...state, metaData: action.payload };
        case actionTypes.SET_GRAP_DATA:
            return { ...state, grapData: action.payload };
        case actionTypes.SET_GRAP_TITLE:
            return { ...state, grapTitle: action.payload };
        case actionTypes.SET_NAME_A:
            return { ...state, nameA: action.payload };
        case actionTypes.SET_NAME_B:
            return { ...state, nameB: action.payload };
        case actionTypes.SET_Y_NAME:
            return { ...state, yName: action.payload };
        case actionTypes.SET_STEP_SIZE:
            return { ...state, stepSize: action.payload };
        case actionTypes.SET_MAX_ANOS:
            return { ...state, maxAnos: action.payload };
        case actionTypes.SET_MIN_ANOS:
            return { ...state, minAnos: action.payload };
        default:
            return state;
    }
}

function Resultados(props) {
    const { estimagasState, estimagasDispatch, defaultParams, dataFetch } = props;
    const [resultadoState, resultadoDispatch] = useReducer(reducer, initialState);

    const [isLoading, setIsLoading] = useState(true); // Estado para controlar o carregamento

    const setShowrsu = (payload) => resultadoDispatch({ type: actionTypes.SET_SHOW_RSU, payload });
    const setMetaData = (payload) => resultadoDispatch({ type: actionTypes.SET_META_DATA, payload });
    const setShowOpGrap = (payload) => resultadoDispatch({ type: actionTypes.SET_SHOW_OP_GRAP, payload });
    const setRelatorio = () => estimagasDispatch({ type: 'TOGGLE_RELATORIO' });
    const setGrapData = (payload) => resultadoDispatch({ type: actionTypes.SET_GRAP_DATA, payload });
    const setGrapTitle = (payload) => resultadoDispatch({ type: actionTypes.SET_GRAP_TITLE, payload });
    const setNameA = (payload) => resultadoDispatch({ type: actionTypes.SET_NAME_A, payload });
    const setNameB = (payload) => resultadoDispatch({ type: actionTypes.SET_NAME_B, payload });
    const setYName = (payload) => resultadoDispatch({ type: actionTypes.SET_Y_NAME, payload });
    const setBiogas = (payload) => resultadoDispatch({ type: actionTypes.SET_BIOGAS, payload });
    const setMax = (payload) => resultadoDispatch({type: actionTypes.SET_MAX_ANOS, payload});
    const setMin = (payload) => resultadoDispatch({type: actionTypes.SET_MIN_ANOS, payload});
    const setStepSize = (payload) => resultadoDispatch({type: actionTypes.SET_STEP_SIZE, payload});

    function metanoNM(metano) {
        let metanoNMData = [];
        for (let i = 0; i < metano?.length; i++) {
            metanoNMData[i] = {
                ano: metano[i]?.ano,
                quantidade: metano[i]?.quantidade * 1265.1
            }
        }
        return metanoNMData;
    }

    function biogasCalc(metano) {
        let biogas = [];
        for (let i = 0; i < metano?.length; i++) {
            biogas[i] = {
                ano: metano[i]?.ano,
                quantidade: ((metano[i]?.quantidade * 1265.1) / 47.60333635623321) * 100
            }
        }
        return biogas
    }

    function getRadioValue(comp) {
        if (comp.target.id === "check-grap-rsu") {
            setShowrsu(true);
            setGrapData(estimagasState.resData);
            setGrapTitle('Resíduos Sólidos Urbanos');
            setNameA(null);
            setNameB(null);
            setYName('Quantidade (t)');
            setBiogas(false);

        } else if (comp.target.id === "check-grap-meta") {
            setGrapData([resultadoState.metaData.metanoConservador[1], resultadoState.metaData.metanoRecomendado[1]]);
            setShowrsu(false);
            setGrapTitle('Metano');
            setNameA('Conservador');
            setNameB('Recomendado');
            setYName('Quantidade (t)');
            setBiogas(false);

        } else if (comp.target.id === "check-grap-co2") {
            setShowrsu(false);
            setGrapData([resultadoState.metaData.coConservador[1], resultadoState.metaData.coRecomendado[1]])
            setGrapTitle('Dioxido de carbono');
            setNameA('Consevador');
            setNameB('Recomendado');
            setYName('Quantidade (t)');
            setBiogas(false);            

        } else if (comp.target.id === "check-grap-bio"){
            setShowrsu(false);
            setGrapData([biogasCalc(resultadoState.metaData.metanoConservador[1]), metanoNM(resultadoState.metaData.metanoConservador[1])]);
            setGrapTitle('Biogás e Metano (NM)');
            setNameA('Biogás');
            setNameB('Metano');
            setYName('Quantidade (M³)');
            setBiogas(true);
        }
    }

    useEffect(() => {
        const fetchMeta = async () => {
          setIsLoading(true); // Inicia o carregamento
          const data = await calcularProjecao(estimagasState.resData, estimagasState.params);
          setMetaData(data);
          setIsLoading(false); // Finaliza o carregamento
          setGrapData([data.metanoConservador[1], data.metanoRecomendado[1]])
        };
    
        if (estimagasState.metaData == null) {
          fetchMeta();
        }
      }, [estimagasState.resData, estimagasState.params]);

      useEffect(()=>{
        console.log(estimagasState.relatorio);
        
      },[estimagasState])

    if (!resultadoState.metaData || Object.keys(resultadoState.metaData).length === 0) {
        return (
            <div className={'noResult'}>
                <div className={'noResultRow'}>
                    <div>
                        <h1>O sistema está processando os resultados</h1>
                        <img src={'/icons/loading.svg'} alt={'loading'} />
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="layout flex flex-col items-center mb-[90px] m-2">
            <div className="w-full flex flex-row justify-center items-center gap-3">
                <div className="flex flex-row gap-2" onChange={(e) => getRadioValue(e)}>
                    <input type="radio" id="check-grap-rsu" name="graph-selector" className="hidden peer" defaultChecked /> 
                    <label htmlFor="check-grap-rsu" className="inline-block cursor-pointer px-4 py-2 rounded-md bg-stone-100 text-sky-500 border border-blue-500 peer-checked:bg-sky-600 peer-checked:text-stone-100 peer-checked:border-blue-700">
                        RSU
                    </label>
                    <input type="radio" id="check-grap-meta" name="graph-selector" className="hidden peer" />
                    <label htmlFor="check-grap-meta" className="inline-block cursor-pointer px-4 py-2 rounded-md bg-stone-100 text-sky-500 border border-blue-500 peer-checked:bg-sky-600 peer-checked:text-stone-100 peer-checked:border-blue-700">
                        CH<sub>4</sub>
                    </label>
                    <input type="radio" id="check-grap-co2" name="graph-selector" className='hidden peer'/>
                    <label htmlFor="check-grap-co2" className="inline-block cursor-pointer px-4 py-2 rounded-md bg-stone-100 text-sky-500 border border-blue-500 peer-checked:bg-sky-600 peer-checked:text-stone-100 peer-checked:border-blue-700 ">
                        CO<sub>2</sub>
                    </label>
                    <input type="radio" id="check-grap-bio" name="graph-selector" className='hidden peer'/>
                    <label htmlFor="check-grap-bio" className="inline-block cursor-pointer px-4 py-2 rounded-md bg-stone-100 text-sky-500 border border-blue-500 peer-checked:bg-sky-600 peer-checked:text-stone-100 peer-checked:border-blue-700">
                        Biogás
                    </label>
                </div> 
                {/* <div className="flex items-center cursor-pointer bg-green-700 border-2 rounded-3xl text-stone-200 p-1" onClick={() => setRelatorio(!resultadoState.relatorio)}>
                    <img src={downIcon} alt="" />
                    <button>Baixar relatório</button>
                </div> */}
                {/* <button className="flex items-center cursor-pointer bg-sky-700 border-2 rounded text-stone-200 p-1" onClick={() => setShowOpGrap(!resultadoState.showOpGrap)}>Opções de gráfico</button> */}
            </div>
            <div className="res-slider-container flex justify-center items-center">
                {!isLoading && (
                    <div>
                        {resultadoState.showrsu ? (
                            <ChartRSU
                                lineData={estimagasState.resData}
                                maxValue={resultadoState.maxAnos}
                                minValue={resultadoState.minAnos}
                            />
                            ) : (
                            <ChartBarLine resultadoState={resultadoState} />
                        )}
                    </div>
                )}
                {isLoading && <p>Carregando dados...</p>}
            </div>
            {estimagasState.relatorio && (
                <div className='absolute top-1/4 left-1/4 w-1/2'>
                    <Relatorio
                        resultadoState={resultadoState}
                        resData={estimagasState.resData}
                        setRelatorio={setRelatorio}
                        metanoNM={metanoNM}
                        biogasCalc={biogasCalc}
                    />
                </div>
            )}
        </div>
    );
}

export default Resultados;
